import { Button } from '@mui/material'
import React from 'react'
import { DoubleButtonProps } from './_props'
import useStyles from './_styles'

const DoubleButton = ({ rightButton, leftButton }: DoubleButtonProps) => {
    const classes = useStyles()
    return (
        <div className={classes.DoubleButton}>
            <Button onClick={leftButton.onClick} className={classes.DoubleButtonButton} disabled={leftButton.disabled}>
                {leftButton.label}
            </Button>
            <div className={classes.DoubleButtonSeparator} />
            <Button
                onClick={rightButton.onClick}
                className={classes.DoubleButtonButton}
                disabled={rightButton.disabled}
            >
                {rightButton.label}
            </Button>
        </div>
    )
}

export default DoubleButton
